
import { defineComponent } from '@vue/runtime-core'
import TheListAbout from '@/components/organisms/TheListAbout.vue'

export default defineComponent({
  name: 'TheSiteDescription',
  components: {
    TheListAbout
  }
})
